import { motion } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";
import { Topo } from "@/components/Graphics";
import { Kicker, CTABand } from "@/components/Bits";
import { SellMobileHome, Principles, HowItWorks } from "@/components/MobileHomeSections";
import { AboutLeadForms } from "@/components/AboutLeadForms";

export default function RealEstate() {
  return (
    <div data-testid="real-estate-page">
      <section className="relative overflow-hidden pt-40 pb-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="pointer-events-none absolute -left-[18%] -top-[8%] w-[70vw] max-w-[760px] text-primary/20"
        >
          <Topo className="w-full h-full" />
        </motion.div>
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <Kicker>Mobile &amp; Manufactured Homes · South Carolina</Kicker>
          <h1 className="font-display tracking-mega leading-[0.86] text-5xl sm:text-7xl lg:text-8xl mt-6 max-w-5xl">
            <MaskedLines lines={["Ready to Sell", "Your Mobile Home?"]} />
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="mt-8 text-lg sm:text-xl text-foreground/75 max-w-2xl leading-relaxed"
          >
            We help mobile and manufactured homeowners explore simple solutions for selling their homes.
            Whether you need to sell quickly, your home needs work, sits in a park, or needs to be moved — we
            make the process simple, friendly, and stress-free.
          </motion.p>
        </div>
      </section>

      <SellMobileHome />
      <Principles />
      <HowItWorks />
      <AboutLeadForms />
      <CTABand />
    </div>
  );
}
